import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { fromLegacy } from '../../lib/marketTaxonomy';
import { keepsLegacyCatalog, useHioBuyOnly } from '../../lib/marketMode';

// Wraps a LEGACY catalog route (/products, /factories, factory pages). In
// HioBuy-only mode a customer is sent to the marketplace instead — to the
// matching marketplace category when /products?cat= names a shared-tree
// category (moved through marketTaxonomy.js LEGACY_MAP). Suppliers
// and admins pass through: their dashboards, claim previews and consoles link
// here. Nothing renders until the switch is known, so a customer never sees a
// flash of the legacy catalog. See lib/marketMode.js.
export default function LegacyCatalogGate({ profile, children }) {
  const { ready, hioBuyOnly } = useHioBuyOnly();
  const loc = useLocation();
  if (!ready) return null;
  if (!hioBuyOnly || keepsLegacyCatalog(profile)) return children;
  const cat = new URLSearchParams(loc.search).get('cat');
  const to = fromLegacy(cat);
  return <Navigate to={to ? `/market/c/${[to.main, to.sub, to.type].filter(Boolean).join('/')}` : '/market'} replace />;
}
